/**
 * Resolve an uploaded file URL so it reliably opens from the browser.
 *
 * Uploaded documents are stored as absolute URLs built from the backend's
 * self-perceived host/port at upload time, which is not always the origin the
 * frontend can reach. Locally-served `/uploads/...` paths are re-based onto
 * `API_BASE_URL`. External URLs (e.g. Azure Blob) are returned unchanged.
 */
import { API_BASE_URL } from '../../services/api/client';

export function resolveFileUrl(url?: string | null): string | null {
  if (!url) return null;
  const trimmed = url.trim();
  if (!trimmed) return null;

  const uploadsIdx = trimmed.indexOf('/uploads/');
  if (uploadsIdx >= 0) {
    return `${API_BASE_URL}${trimmed.slice(uploadsIdx)}`;
  }

  if (trimmed.startsWith('/')) {
    return `${API_BASE_URL}${trimmed}`;
  }

  return trimmed;
}
